var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 5.83335C11.6668 8.74594 8.43575 11.7793 7.35075 12.7161C7.24967 12.7921 7.12663 12.8332 7.00016 12.8332C6.8737 12.8332 6.75066 12.7921 6.64958 12.7161C5.56458 11.7793 2.3335 8.74594 2.3335 5.83335C2.3335 4.59568 2.82516 3.40869 3.70033 2.53352C4.5755 1.65835 5.76249 1.16669 7.00016 1.16669C8.23784 1.16669 9.42483 1.65835 10.3 2.53352C11.1752 3.40869 11.6668 4.59568 11.6668 5.83335Z",
    stroke: "#0079FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 7.58335C7.96666 7.58335 8.75016 6.79985 8.75016 5.83335C8.75016 4.86686 7.96666 4.08335 7.00016 4.08335C6.03366 4.08335 5.25016 4.86686 5.25016 5.83335C5.25016 6.79985 6.03366 7.58335 7.00016 7.58335Z",
    stroke: "#0079FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.434ee6a504b3b19292669d7317ffa65e.svg";
export { ForwardRef as ReactComponent };